import React, {ReactNode} from "react";
import Button from "../Button";

interface ButtonProps {
    href: string;
}

const PayByStripeButton: React.FC<ButtonProps> = ({href}) => {

    const handlePayment = async () => {
        window.location.href = href;
    };

    return (
        <Button style="primary" className="mb-0 stripe-bg" type="button"  onClick={handlePayment}>
            <i className="fa-brands fa-stripe-s mr-2"></i>  Pay by Stripe
        </Button>
    );
};

export default PayByStripeButton;
